import { useCallback, useEffect, useState } from 'react';
import { applyTheme, loadTheme, resolveTheme, saveTheme, type ThemePref } from './theme.ts';

const LIGHT_QUERY = '(prefers-color-scheme: light)';

function systemPrefersLight(): boolean {
  return typeof window !== 'undefined' && !!window.matchMedia?.(LIGHT_QUERY).matches;
}

/** 目前的主題偏好與切換函式；偏好為「跟隨系統」時，系統切換深淺色會即時套用 */
export function useTheme(): [ThemePref, (pref: ThemePref) => void] {
  const [pref, setPref] = useState<ThemePref>(loadTheme);

  useEffect(() => {
    applyTheme(resolveTheme(pref, systemPrefersLight()));
    if (pref !== 'system' || !window.matchMedia) return;
    const mq = window.matchMedia(LIGHT_QUERY);
    const onChange = () => applyTheme(resolveTheme('system', mq.matches));
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [pref]);

  const set = useCallback((next: ThemePref) => {
    saveTheme(next);
    setPref(next);
  }, []);

  return [pref, set];
}
